<template>
  <el-card style="margin-bottom:20px;">
    <div slot="header" class="clearfix">
      <span>About me</span>
    </div>

    <div class="user-profile">
      <div class="box-center">
        <div class="user-name text-center">{{ user.name }}</div>
        <div class="user-role text-center text-muted">{{ user.role | uppercaseFirst }}</div>
        <avatar-upload :image_url="user.profile_pic_url" @image-updated="updateProfilePic"></avatar-upload>
      </div>
    </div>
  </el-card>
</template>

<script>

import { mapActions } from 'vuex'
import avatarUpload from '../../components-demo/avatar-upload.vue'
import UserResource from '@/api/user'
const userResource = new UserResource()

export default {
  components: { avatarUpload },
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          id: 0,
          name: '',
          email: '',
          profile_pic_url: '',
          roles: ''
        }
      }
    }
  },
  data: function () {
    return {
      errorCodeMessage: {
        0: { 'type': 'success', 'title': ' Success', 'message': ' Success' },
        1: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Something went wrong, please try again.' },
        4: { 'type': 'warning', 'title': 'Warning', 'message': 'Please try again.' },
        5: { 'type': 'error', 'title': 'Nothing Changes', 'message': 'Nothing Changes' }
      }
    }
  },
  methods: {
    ...mapActions({
      getUserInfo: 'user/getInfo'
    }),
    async updateProfilePic(new_url) {
      console.log("Update Profile Pic: " + new_url)
      console.log(this.user)
      const params = {
        'userId': this.user.userId,
        'profile_pic_url': new_url
      }
      const { data } = await userResource.updateSelf(params)
      const actionTitle = 'Update Avatar'
      if (data.code === 0) {
        this.messageNotify(
          actionTitle,
          this.errorCodeMessage[data.code]['message'],
          'success'
        )
        // Update user info in state
        this.getUserInfo();
      } else {
        this.messageNotify(
          actionTitle,
          data.errors,
          'error'
        )
        return false
      }
    },
    messageNotify(title, message, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: `<div>${message}</div>`,
        type: type
      })
    }
  }
}
</script>

<style lang="scss" scoped>
 .box-center {
   margin: 0 auto;
   display: table;
 }

 .text-muted {
   color: #777;
 }

 .user-profile {
   .user-name {
     font-weight: bold;
   }

   .box-center {
     padding-top: 10px;
   }

   .user-role {
     padding-top: 10px;
     font-weight: 400;
     font-size: 14px;
   }

   .box-social {
     padding-top: 30px;

     .el-table {
       border-top: 1px solid #dfe6ec;
     }
   }

   .user-follow {
     padding-top: 20px;
   }
 }

 .user-bio {
   margin-top: 20px;
   color: #606266;

   span {
     padding-left: 4px;
   }

   .user-bio-section {
     font-size: 14px;
     padding: 15px 0;

     .user-bio-section-header {
       border-bottom: 1px solid #dfe6ec;
       padding-bottom: 10px;
       margin-bottom: 10px;
       font-weight: bold;
     }
   }
 }
</style>
